import { useSelector } from "../../hooks";
import { Loader } from "../../components/Loader/Loader";
import { ErrorSnackbar } from "../../components/ErrorSnackbar/ErrorSnackbar";
import { DrawContext, DrawRoutes } from "./DrawRoutes";
import { ContentWrapper } from "../../components/ContentWrapper/ContentWrapper";
import { PageTabPanel } from "../../components/PageTabPanel/PageTabPanel";
import { AppContext } from "../../components/Menu/MenuButton";
import { useLocation } from "react-router-dom";

const DRAWS_TABS = [{
    name: 'Интерактивные',
    context: `/${AppContext.Draw}/${DrawContext.Interactive}`,
}, {
    name: 'Авто',
    context: `/${AppContext.Draw}/${DrawContext.Automatic}`,
}];

export const DrawPage = () => {    
    const { loading, error } = useSelector(store => store.draws);
    const location = useLocation();

    const isNeedTabs = () => {
        return !location.pathname.includes(DrawContext.Winners);
    }

    return (
        <ContentWrapper noTopPadding={ isNeedTabs() }>
            { isNeedTabs() && 
                <PageTabPanel tabs={ DRAWS_TABS }/>
            }

            <DrawRoutes />

            { loading && <Loader /> }
            { error.length > 0 && <ErrorSnackbar errorMessage={ error } /> }
        </ContentWrapper>
    );
}